import { noop, isFunction } from 'lodash'

//   TRACE: 0,
//   DEBUG: 1,
//   INFO: 2,
//   WARN: 3,
//   ERROR: 4,
//   SILENT: 5

// (process.env.DEBUG || process.env.NODE_ENV === 'development')

function bindMethod (obj, methodName) {
  const method = obj[methodName]

  if (isFunction(method.bind)) {
    return method.bind(obj)
  }
}

const $logger = {}

$logger.info = bindMethod(console, 'info')
$logger.warn = bindMethod(console, 'warn')
$logger.error = bindMethod(console, 'error')

if (process.env.NODE_ENV === 'development') {
  $logger.debug = bindMethod(console, 'log')
} else {
  $logger.debug = noop
}

export default $logger
